import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`PowerPoint templates are available for download to the members of the GitHub organization on `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1mnxk1oVKw1-RtAy5iQpXPSNbxBvbrKox"
      }}>{`Google Drive`}</a>{`.`}</p>
    <h3>{`Creating a new presentation`}</h3>
    <p>{`A new presentation can be created using either the `}<inlineCode parentName="p">{`.potx`}</inlineCode>{` file or the `}<inlineCode parentName="p">{`.pptx`}</inlineCode>{` file.`}</p>
    <h4>{`.potx vs .pptx: What's the difference?`}</h4>
    <p>{`Both the `}<inlineCode parentName="p">{`.potx`}</inlineCode>{` and the `}<inlineCode parentName="p">{`.pptx`}</inlineCode>{` will open and create a new document.`}</p>
    <ul>
      <li parentName="ul">{`A `}<inlineCode parentName="li">{`.potx`}</inlineCode>{` is a template file which will create a new presentation with the presentation system theming (slides, colors, type) already in place.`}</li>
      <li parentName="ul">{`A `}<inlineCode parentName="li">{`.pptx`}</inlineCode>{` will open like a normal file. When using select `}<strong parentName="li">{`Save a Copy`}</strong>{` or rename the file specific to the presentation.`}</li>
    </ul>
    <p><strong parentName="p">{`Tip:`}</strong>{` The design systems team recommends using the template(`}<inlineCode parentName="p">{`.potx`}</inlineCode>{`) file as this will start a fresh document with everything loaded right away. 😄`}</p>
    <h3>{`Installing the PowerPoint themes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Screenshot`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`To install, open a new document and open the `}<strong parentName="td">{`Slide Master`}</strong>{`.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/57048191-d552ab80-6c27-11e9-81c5-3ca6c61ac6bf.png",
              "alt": "Open Slide master"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Click the `}<strong parentName="td">{`Theme`}</strong>{` button to open the theme window.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/57048292-4003e700-6c28-11e9-9f34-600c15feb4de.png",
              "alt": "Click the theme button"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`At the bottom, click on `}<strong parentName="td">{`Browse for Themes`}</strong>{`.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/57048344-6a55a480-6c28-11e9-8f61-70ed23816606.png",
              "alt": "Browse for Themes"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Navigate to your `}<inlineCode parentName="td">{`github-presentation-system-powerpoint`}</inlineCode>{` folder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/57048569-58283600-6c29-11e9-890c-f75694b67d5a.png",
              "alt": "Navigate to your file"
            }}></img></td>
        </tr>
      </tbody>
    </table>
    <Note mdxType="Note">
      <p>{`😕 `}<strong parentName="p">{`Having trouble?`}</strong>{` Message us in `}<a parentName="p" {...{
          "href": "https://github.slack.com/messages/C0ZCGGGJ2"
        }}>{`#design-systems`}</a>{` for assistance.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      